<span class="banner">
    <span class="banner__title">{{ title }}: </span>
    {{ values }}
</span>
<ui-icon
    tabindex="0"
    class="close-icon"
    role="button"
    [attr.aria-label]="'Filter entfernen: ' + title"
    [icon]="'close-small'"
/>
